import { __extends } from "tslib";
import { DateTimeFormats_$type } from "./DateTimeFormats";
import { EditorType_$type } from "./EditorType";
import { IgrColumn } from "./igr-column";
import { DateTimeColumn } from "./DateTimeColumn";
import { ensureEnum, arrayFindByName } from "igniteui-react-core";
/**
 * A column for displaying date/time values.
*/
var IgrDateTimeColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrDateTimeColumn, _super);
    function IgrDateTimeColumn(props) {
        return _super.call(this, props) || this;
    }
    IgrDateTimeColumn.prototype.createImplementation = function () {
        return new DateTimeColumn();
    };
    Object.defineProperty(IgrDateTimeColumn.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "dateTimeFormat", {
        /**
         * Gets or sets the date time format to use for this column. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.kz;
        },
        set: function (v) {
            this.i.kz = ensureEnum(DateTimeFormats_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "formatString", {
        /**
         * Gets or sets the format string to apply to the value. If set, the other value formatting properties on this column are ignored.
        */
        get: function () {
            return this.i.ld;
        },
        set: function (v) {
            this.i.ld = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "editorFormatString", {
        /**
         * Gets or sets the format string to use when editing dates.
        */
        get: function () {
            return this.i.k8;
        },
        set: function (v) {
            this.i.k8 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "formatSpecifiers", {
        get: function () {
            return this.i.kw;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.kw = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "formatOverride", {
        /**
         * Gets or sets the INTL DateTimeFormat object to use for formatting the date values.
        */
        get: function () {
            return this.i.k4;
        },
        set: function (v) {
            this.i.k4 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "editorType", {
        /**
         * Gets or sets the editor type used for editing cells in this column.
        */
        get: function () {
            return this.i.k0;
        },
        set: function (v) {
            this.i.k0 = ensureEnum(EditorType_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "editorDataSource", {
        /**
         * Gets or sets the ComboBox data source.
        */
        get: function () {
            return this.i.k3;
        },
        set: function (v) {
            this.i.k3 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "editorTextField", {
        /**
         * Gets or sets the ComboBox text field.
        */
        get: function () {
            return this.i.la;
        },
        set: function (v) {
            this.i.la = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "editorValueField", {
        /**
         * Gets or sets the ComboBox value field.
        */
        get: function () {
            return this.i.kv;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.kv = v;
        },
        enumerable: false,
        configurable: true
    });
    IgrDateTimeColumn.prototype.findByName = function (name) {
        var baseResult = _super.prototype.findByName.call(this, name);
        if (baseResult) {
            return baseResult;
        }
        if (this.formatSpecifiers != null && arrayFindByName(this.formatSpecifiers, name)) {
            return arrayFindByName(this.formatSpecifiers, name);
        }
        return null;
    };
    return IgrDateTimeColumn;
}(IgrColumn));
export { IgrDateTimeColumn };
//# sourceMappingURL=igr-date-time-column.js.map
